import { render, staticRenderFns } from "./DataWithTitleOnBottom.vue?vue&type=template&id=5bf9c274&scoped=true&"
import script from "./DataWithTitleOnBottom.vue?vue&type=script&lang=js&"
export * from "./DataWithTitleOnBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf9c274",
  null
  
)

export default component.exports